module.exports = __webpack_public_path__ + "media/luxury-2026/pool-house-aerial-960-41d26651.jpg";